export default __webpack_public_path__ + "static/media/banner3b.4abcba7b.jpg";